import React, { useState } from 'react'
import PropTypes from 'prop-types'

import { StripeCheckoutProvider, useUserContext } from 'context'
import { Feedback } from 'ui/bend'

import ActiveMembership from './ActiveMembership'
import InactiveMembership from './InactiveMembership'

const EditMembership = ({ stripeApiKey }) => {
  const [error, setError] = useState()
  const { user } = useUserContext()

  const handleError = (error) => {
    if (error.message) {
      setError(error.message)
    } else {
      setError(
        'We apologize, but there has been an error. Please contact support@alomoves.com for additional assistance.'
      )
    }
  }

  return (
    <StripeCheckoutProvider stripeApiKey={stripeApiKey}>
      {user.hasSubscriptionAccess ? (
        <ActiveMembership handleError={handleError} />
      ) : (
        <InactiveMembership handleError={handleError} />
      )}
      {error && <Feedback className='error'>{error}</Feedback>}
    </StripeCheckoutProvider>
  )
}

EditMembership.propTypes = {
  stripeApiKey: PropTypes.string.isRequired
}

export default EditMembership
